const processsearchresultsItem = require('./processsearchresults-item');

module.exports = (items) => items
  .filter((item) => (
    typeof item.moviesCount === 'undefined'
      || item.moviesCount > 0
  ) && (
    typeof item.clipsCount === 'undefined'
    || item.clipsCount > 0
  ))
  .map(processsearchresultsItem);



// WEBPACK FOOTER //
// ./src/_utilities/processsearchresults.js